import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

/**
 * Sdílený prázdný stav – zobrazí se, když není co zobrazit (prázdný filtr, žádné záznamy).
 * @param {React.ReactNode} icon - Ikona (Lucide nebo jiná komponenta)
 * @param {string} title - Hlavní text (např. "Žádná data k dispozici")
 * @param {string} [description] - Volitelný doplňující text
 * @param {React.ReactNode} [action] - Volitelné CTA (tlačítko nebo odkaz)
 * @param {string} [className] - Další třídy pro obal Card
 */
export const EmptyState = ({ icon: Icon, title, description, action, className }) => {
  return (
    <Card className={cn('shadow-soft', className)}>
      <CardContent className="p-12 text-center">
        {Icon && (
          <div className="flex justify-center mb-4" aria-hidden>
            {typeof Icon === 'function' ? (
              <Icon className="w-12 h-12 text-muted-foreground mx-auto" />
            ) : (
              Icon
            )}
          </div>
        )}
        <p className="text-foreground font-medium mb-1">{title}</p>
        {description && (
          <p className="text-sm text-muted-foreground mb-4 max-w-sm mx-auto">{description}</p>
        )}
        {action && <div className="mt-4">{action}</div>}
      </CardContent>
    </Card>
  );
};
